import { makeStyles } from '@material-ui/styles'

export const useEvaluationGoalReviewStyles = makeStyles((theme) => ({
  root: { paddingBottom: theme.spacing(12) },
}))
